import React, { Component } from 'react';
import './style.css';
import { URL_START } from '../../constants';
import { translate } from 'react-i18next';
import { Checkbox, CheckboxGroup } from 'react-checkbox-group';
import { RadioGroup, Radio } from 'react-radio-group';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faCheck } from '@fortawesome/free-solid-svg-icons';

class Question extends Component {
  constructor(props) {
    super(props);
    this.state = { value: this.props.question.answer };
    this.handleChange = this.handleChange.bind(this);
    this.handleChangeText = this.handleChangeText.bind(this);
  }

  handleChange(value) {
    this.setState({ value: value });
  }

  handleChangeText(event) {
    this.setState({ value: event.target.value });
  }

  componentWillReceiveProps(nextProps, nextState) {
    this.setState({ value: nextProps.question.answer });
  }

  render() {
    const { t } = this.props;
    let questionElem;

    switch (this.props.question.value_type) {
      case 'Checkbox':
        questionElem = (
          <CheckboxGroup
            name="checkboxQuestion"
            value={this.state.value}
            onChange={this.handleChange}
            checkboxDepth={3}
          >
            {this.props.question.answers_questions.map(answer => (
              <div key={answer.uuid} className="checkbox-container">
                <Checkbox
                  className="checkbox-element"
                  value={answer.uuid}
                  id={answer.uuid}
                />
                <label className="checkbox-label" for={answer.uuid}>
                  <FontAwesomeIcon icon={faCheck} className="checked-icon" />
                  {answer.answer}
                </label>
              </div>
            ))}
          </CheckboxGroup>
        );
        break;

      case 'Text':
        questionElem = (
          <div className="text-input-container">
            <textarea
              autoFocus
              className="text-input"
              placeholder={t('Placeholder text')}
              rows="1"
              onChange={this.handleChangeText}
              value={this.state.value}
            />
          </div>
        );
        break;

      case 'Radio':
      default:
        questionElem = (
          <RadioGroup
            name="radioQuestion"
            value={this.state.value}
            onChange={this.handleChange}
          >
            {this.props.question.answers_questions.map(answer => (
              <div key={answer.uuid} className="checkbox-container">
                <Radio
                  className="checkbox-element"
                  value={answer.uuid}
                  id={answer.uuid}
                />
                <label className="checkbox-label" for={answer.uuid}>
                  {answer.answer}
                </label>
              </div>
            ))}
          </RadioGroup>
        );
        break;
    }

    return (
      <div className="card-body">
        <h1 className="h6 text-muted">{this.props.completionStatus}</h1>
        <div className="question">{this.props.question.question}</div>
        <div className="question-container">{questionElem}</div>
        <div className="actions">
          <Link to={URL_START + '/' + this.props.projectObjectUuid + '/'}>
            <button
              className="btn btn-primary btn-round btn-next"
              onClick={() =>
                this.props.save(this.state.value, this.props.question.uuid)
              }
              disabled={!this.state.value}
            >
              Next <FontAwesomeIcon icon={faArrowRight} />
            </button>
          </Link>
        </div>
      </div>
    );
  }
}

export default translate('translations')(withRouter(Question));



// WEBPACK FOOTER //
// ./src/comparison-new/components/Question/index.js